"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REDUCER_READ_EMIRATES_ID = exports.REDUCER_GET_STATE_LIST = exports.REDUCER_GET_NATIONALITY_LIST = exports.REDUCER_GET_COUNTRY_LIST = exports.REDUCER_GET_CITY_LIST = exports.REDUCER_GET_BLOB_NATIONALITY_LIST = exports.GET_CITIES_DATA = void 0;
const REDUCER_GET_CITY_LIST = exports.REDUCER_GET_CITY_LIST = 'getCityListApi';
const REDUCER_GET_COUNTRY_LIST = exports.REDUCER_GET_COUNTRY_LIST = 'getCountryListApi';
const REDUCER_GET_NATIONALITY_LIST = exports.REDUCER_GET_NATIONALITY_LIST = 'getNationalityList';
const REDUCER_GET_STATE_LIST = exports.REDUCER_GET_STATE_LIST = 'getStateListApi';
const REDUCER_READ_EMIRATES_ID = exports.REDUCER_READ_EMIRATES_ID = 'readEmiratesID';
const REDUCER_GET_BLOB_NATIONALITY_LIST = exports.REDUCER_GET_BLOB_NATIONALITY_LIST = 'getNationalityBlobList';
const GET_CITIES_DATA = exports.GET_CITIES_DATA = 'getCitiesData';